import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useViewTransitionNavigate } from 'services/useViewTransitionNavigate';
import './AuthPageLink.scss';

// Same rule react-router's own <Link> applies: only a plain left click is taken over, so ctrl/cmd/shift/middle
// click still opens the page in a new tab/window through the regular href.
const isPlainLeftClick = (e) => e.button === 0 && !e.metaKey && !e.altKey && !e.ctrlKey && !e.shiftKey;

// TRN-7473 — link between the Login and Registration pages. Used to be a plain <a href>, i.e. a full page reload
// with a blank flash in between; now an in-app navigation animated with the View Transitions API: the brand panel
// stays put and only the right-hand content cross-fades (styles in AuthPageLink.scss).
//
// isDisabled: inert while the page's own request is in flight — a full page reload used to abort it, an in-app
// navigation doesn't, so its late response would land in a store the other page already reset (e.g. begin()
// moving a fresh registration to its Confirm step, or a login's 2FA token arriving on the Registration page).
const AuthPageLink = ({ to, className, isDisabled, children }) => {
  const navigateWithTransition = useViewTransitionNavigate();

  const handleClick = (e) => {
    if (!isPlainLeftClick(e)) return;

    e.preventDefault();
    if (isDisabled) return;

    navigateWithTransition(to);
  };

  return (
    <Link to={to} className={className} onClick={handleClick} aria-disabled={isDisabled || undefined}>
      {children}
    </Link>
  );
};

AuthPageLink.propTypes = {
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  children: PropTypes.node
};

export default AuthPageLink;
